
import { computed, defineComponent, PropType } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import offersStore from '../offers.store';
import utilities from '@/shared/utilities.service';
import { PersonalOfferOverviewModel } from '@/b2c/shared/api/server-apis';
import ProductCollage from '@/b2c/shared/product/ui/ProductCollage.vue';
import StoreName from '@/b2c/shared/stores/ui/StoreName.vue';

export default defineComponent({
    name: 'OffersThumbView',
    components: { StoreName, ProductCollage },
    props: {
        model: {
            type: Array as PropType<PersonalOfferOverviewModel[]>,
            required: true,
        },
        detailsUrl: {
            type: String,
            required: false,
            default: '',
        },
    },
    setup(props) {
        const labels = useBlockLabels();
        const isEmptyResult = computed(() => {
            return !props.model?.length;
        });

        const getDetailsLocation = (id: string) => {
            return offersStore.getDetailsLocation(id, props.detailsUrl);
        };

        return {
            labels,
            formatDate: utilities.formatDate,
            isEmptyResult,
            getDetailsLocation,
        };
    },
});
